module.exports = __webpack_public_path__ + "a0a5fb1a6c212edaf327ea0ffd56affc.png";